<template>
  <div>
    <div class="tool">
      <img class="tool__icon" :src="iconSrc"/>
      <div class="tool__info">
        <p class="tool__text mb-2" v-html="$t(`products.tools.${route.name}`)" />
        <b-btn variant="primary" size="sm" :to="{ name: route.name }">{{$t(`learn-more`)}}</b-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolSlide',
  props: {
    route: Object,
    tag: String
  },
  computed: {
    iconSrc: app => require(`@/assets/home/tools/${app.route.path}-icon-and-name.png`)
  }
}
</script>

<style lang="sass" scoped>
.tool
  display: grid
  grid-template-columns: 100% minmax(0, 1fr)
  grid-template-areas: 'icon header' 'info info'
  grid-gap: 14px
  align-content: start
  align-items: center
  padding: $spacer / 2
  position: relative
  height: 100%
  border-radius: 4px
  background: transparent
  overflow: hidden
  color: $white

  &__icon
    grid-area: icon
    height: 50px

  &__header
    grid-area: header

  &__title
    margin-bottom: 0

  &__tag
    font-size: 16px
    font-weight: bold
    color: #FFF8D3

  &__info
    grid-area: info

    .btn
      padding: 0 10px

  &__text
    line-height: 1.375rem
</style>



// WEBPACK FOOTER //
// src/components/ui/ToolSlide.vue